import React from "react";
import { IconButton, Menu } from "@material-ui/core";
import { MoreVert as MoreVertIcon } from "@material-ui/icons";

interface Props {
  className?: string;
  children?: React.ReactNode;
  icon?: React.ReactNode;
  size?: "small" | "medium";
}

export default ({ className, children, icon, size }: Props) => {
  const [anchor, setAnchor] = React.useState<HTMLElement | undefined>(
    undefined
  );
  return (
    <span className={className}>
      <IconButton
        size={size}
        onClick={(e: React.MouseEvent<HTMLElement>) => {
          setAnchor(e.currentTarget);
        }}
      >
        {icon ? icon : <MoreVertIcon />}
      </IconButton>
      <Menu
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClick={() => setAnchor(undefined)}
      >
        {children}
      </Menu>
    </span>
  );
};
